<template>
  <v-alert
    prominent
    outlined
    type="info"
    border="left"
    color="defaultColor"
    class="mt-5"
  >
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    show: false,
  }),
  watch: {},
  computed: {},
};
</script>
